window.theme.component('coupon-box', el => {
	const copyButton = el.querySelector('.js-coupon-copy');
	const box = el.querySelector('.js-coupon-box');

	if (!copyButton || !box) return;

	const defaultLabel = copyButton.dataset.defaultLabel || '';
	const successLabel = copyButton.dataset.successLabel || 'Cupom copiado!';
	const errorLabel = copyButton.dataset.errorLabel || 'Nao foi possivel copiar. Abrindo loja...';

	const setLabel = (label, iconClass) => {
		const icon = copyButton.querySelector('i');
		const labelNode = copyButton.querySelector('.button-text');

		if (icon) {
			icon.className = iconClass;
		}

		if (labelNode) {
			labelNode.textContent = label;
		}
	};

	const openStore = () => {
		const link = box.dataset.link;
		if (!link) return;
		window.open(link, '_blank', 'noopener,noreferrer');
	};

	copyButton.addEventListener('click', async () => {
		const coupon = box.dataset.coupon;

		if (!coupon) {
			openStore();
			return;
		}

		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(coupon);
				setLabel(successLabel, 'ri-check-line');
			}
		} catch (error) {
			setLabel(errorLabel, 'ri-error-warning-line');
		}

		openStore();

		window.setTimeout(() => {
			setLabel(defaultLabel, 'ri-file-copy-line');
		}, 3000);
	});
});
